/* eslint-disable no-undef */
/* c8 ignore start */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { BehaviorSubject } from "rxjs";
import { IState } from "./interfaces";
import { ConnectResponse, EnhancerOptions } from "./interfaces/devtools";

export function inspect(
  name = "Qodly",
  subject: BehaviorSubject<IState>,
  opts: Omit<EnhancerOptions, "name"> = {}
): ConnectResponse | undefined {
  const hasReduxDevtools =
    window && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined";

  if (!hasReduxDevtools) {
    console.error(
      "You must have Redux DevTools Extension installed in order to use qodly inspector."
    );
    return;
  }

  const connection: ConnectResponse | undefined =
    window.__REDUX_DEVTOOLS_EXTENSION__?.connect({
      ...opts,
      name,
      trace: true,
      features: {
        ...opts.features,
        pause: true, // start/pause recording of dispatched actions
        lock: true, // lock/unlock dispatching actions and side effects
        export: true, // export history of actions in a file
        import: "custom", // import history of actions from a file
        jump: true, // jump back and forth (time travelling)

        skip: true, // Cannot skip for we cannot replay.
        reorder: true, // Cannot skip for we cannot replay.
        persist: true, // Avoid trying persistence.
        dispatch: true,
        test: false,
      },
    });

  connection?.init({});
  subject.subscribe((state) => {
    connection?.send({ type: "@@UPDATE" }, state);
  });

  connection?.subscribe((data: any) => {
    if (typeof data?.state === "string") {
      subject.next(JSON.parse(data.state as string) as IState);
    }
  });

  return connection;
}
